var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarmProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 79,
    viewBox: "0 0 67 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6946 64.9581C55.6767 61.3261 66 48.6186 66 33.5C66 15.5507 51.4493 1 33.5 1C15.5507 1 1 15.5507 1 33.5C1 48.1716 10.7218 60.5725 24.0749 64.6123L33 78L41.6946 64.9581Z",
    fill: "#00C781"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6946 64.9581L41.5689 64.4742L41.3843 64.5221L41.2786 64.6808L41.6946 64.9581ZM24.0749 64.6123L24.4909 64.3349L24.3914 64.1857L24.2197 64.1337L24.0749 64.6123ZM33 78L32.584 78.2774L33 78.9014L33.416 78.2774L33 78ZM65.5 33.5C65.5 48.3853 55.336 60.898 41.5689 64.4742L41.8203 65.4421C56.0174 61.7542 66.5 48.8519 66.5 33.5H65.5ZM33.5 1.5C51.1731 1.5 65.5 15.8269 65.5 33.5H66.5C66.5 15.2746 51.7254 0.5 33.5 0.5V1.5ZM1.5 33.5C1.5 15.8269 15.8269 1.5 33.5 1.5V0.5C15.2746 0.5 0.5 15.2746 0.5 33.5H1.5ZM24.2197 64.1337C11.0716 60.156 1.5 47.9451 1.5 33.5H0.5C0.5 48.398 10.372 60.9891 23.9301 65.0909L24.2197 64.1337ZM33.416 77.7226L24.4909 64.3349L23.6588 64.8896L32.584 78.2774L33.416 77.7226ZM41.2786 64.6808L32.584 77.7226L33.416 78.2774L42.1106 65.2355L41.2786 64.6808Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_892_13783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6196 50.3125C44.7584 50.3125 53.7881 43.3301 53.7881 34.7168C53.7881 26.1035 44.7584 19.1211 33.6196 19.1211C22.4809 19.1211 13.4512 26.1035 13.4512 34.7168C13.4512 43.3301 22.4809 50.3125 33.6196 50.3125Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2542 31.3821C48.2542 39.4646 41.7009 50.3139 33.6197 50.3139C25.5384 50.3139 18.9863 39.4658 18.9863 31.3821C19.0215 27.5241 20.5787 23.8359 23.3193 21.1202C26.0599 18.4045 29.762 16.8809 33.6203 16.8809C37.4785 16.8809 41.1806 18.4045 43.9212 21.1202C46.6618 23.8359 48.2191 27.5241 48.2542 31.3821Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6211 25.0293V50.313",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1113 27.9961L33.621 32.1126L39.1306 27.9961",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0156 37.0215L33.6199 41.9547L40.223 37.0215",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9219 50.3125H29.3164V53.7057H37.9219V50.3125Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_892_13783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.7629,
    height: 39.3843,
    fill: "white",
    transform: "translate(12.2383 15.5352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarmProduct);
export default __webpack_public_path__ + "static/media/farm-product.3e527ab21cfc88fba4cea9ed59f6661e.svg";
export { ForwardRef as ReactComponent };